import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=5c41e74e&"
import script from "./CustomerProfile.vue?vue&type=script&lang=js&"
export * from "./CustomerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c41e74e')) {
      api.createRecord('5c41e74e', component.options)
    } else {
      api.reload('5c41e74e', component.options)
    }
    module.hot.accept("./CustomerProfile.vue?vue&type=template&id=5c41e74e&", function () {
      api.rerender('5c41e74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/CustomerProfile.vue"
export default component.exports